/* eslint-disable  */
import React, { useEffect } from "react";
import { MdFavoriteBorder } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { bindActionCreators } from "redux";
import { userDataActionCreators } from "../../../../../service/action-creators";
import { GetUserProfile } from "../../../../../service/action-creators/authAction";
import { GetNotifications } from "../../../../../service/action-creators/notificationAction";
import { ResetProductResponse } from "../../../../../service/action-creators/ProductAction";
import Loader from "../../../../Loader";
import RenderHome from "../../../home/RenderHome";
import ProductCard from "./ProductCard";
import "./FavouriteProducts.css";

function FavouriteProducts() {
  const dispatch = useDispatch();
  const { GetFavoriteProducts, GetCartProducts, ResetUserDataResponse } = bindActionCreators(
    userDataActionCreators,
    dispatch
  );
  const user = useSelector((state) => state?.user);
  const productData = useSelector((state) => state?.product);
  const favoriteProducts = user?.favoriteProducts;

  useEffect(() => {
    GetFavoriteProducts();
    GetCartProducts();
    dispatch(GetUserProfile());
    dispatch(GetNotifications());
  }, []);

  useEffect(() => {
    if (user?.response?.state === "SUCCESS" || productData?.response?.state === "SUCCESS") {
      GetFavoriteProducts();
      GetCartProducts();
      setTimeout(() => {
        ResetUserDataResponse();
        dispatch(ResetProductResponse());
      }, 1500);
    } else if (user?.response?.state === "ERROR" || productData?.response?.state === "ERROR") {
      setTimeout(() => {
        ResetUserDataResponse();
        dispatch(ResetProductResponse());
      }, 1500);
    }
  }, [user?.response?.state || productData.response.state]);

  return (
    <div className="FavouriteProducts">
      <RenderHome >
        {(user?.isLoading || productData?.isLoading) && <Loader />}

        {/* Header bar */}
        <div className="favPage-header">
          <div className="favPage-headerLeft">
            <MdFavoriteBorder size={20} color="#e53935" />
            <span>My Favourites</span>
            {favoriteProducts?.length > 0 && (
              <span className="favPage-count">{favoriteProducts.length} item{favoriteProducts.length !== 1 ? "s" : ""}</span>
            )}
          </div>
        </div>

        {favoriteProducts?.length > 0 ? (
          <div className="favPage-grid">
            {favoriteProducts.map((product, index) => (
              <ProductCard key={index} product={product} />
            ))}
          </div>
        ) : (
          <div className="favPage-empty">
            <div className="favPage-emptyIcon">🤍</div>
            <h3 className="favPage-emptyTitle">No favourites yet</h3>
            <p className="favPage-emptySub">
              Tap the heart icon on any product to save it here.
            </p>
          </div>
        )}
      </RenderHome>
      <ToastContainer autoClose={3000} />
    </div>
  );
}

export default FavouriteProducts;
